import { forEach, omit } from 'lodash';
import {
  GET_USER_PLACES_DONE,
  GET_SPOTS_DONE,
  GET_SPOTS_LOT_DONE,
  ADD_SPOT_DONE,
  EDIT_SPOT_DONE,
  DELETE_SPOT_DONE
} from '../actions/constantsActions';

const parkingSpotReducer = (state = {}, action) => {
  const { type, payload } = action;
  const newState = {};

  switch (type) {
    case GET_USER_PLACES_DONE:
      forEach(payload, (place) => {
        newState[place.placeId] = {
          ...state[place.placeId],
          ...{
            address: place.address,
            userId: place.userId,
            floor: place.floor,
            placeId: place.placeId,
            place: place.place,
            shares: place.shares
          }
        };
      });

      return {
        ...state,
        ...newState
      };

    case GET_SPOTS_DONE:
      forEach(payload, (place) => {
        newState[place.id] = {
          ...state[place.id],
          ...{
            floor: place.floor,
            placeId: place.id,
            active: place.active,
            place: place.place
          }
        };
      });

      return {
        ...state,
        ...newState
      };

    case GET_SPOTS_LOT_DONE:
      forEach(payload, (place) => {
        newState[place.id] = {
          ...state[place.id],
          ...{
            floor: place.floor,
            placeId: place.id,
            active: place.active,
            parkingLotId: place.parkingLotId,
            permanentUserId: place.permanentUserId,
            permanentUserName: place.permanentUserName,
            place: place.place
          }
        };
      });

      return {
        ...state,
        ...newState
      };

    case ADD_SPOT_DONE:
      newState[payload.id] = {
        floor: payload.floor,
        placeId: payload.id,
        active: payload.active,
        parkingLotId: payload.parkingLotId,
        permanentUserId: payload.permanentUserId,
        permanentUserName: payload.permanentUserName,
        place: payload.place
      };

      return {
        ...state,
        ...newState
      };

    case EDIT_SPOT_DONE:
      newState[payload.id] = {
        floor: payload.floor,
        placeId: payload.id,
        active: payload.active,
        parkingLotId: payload.parkingLotId,
        permanentUserId: payload.permanentUserId,
        permanentUserName: payload.permanentUserName,
        place: payload.place
      };

      return {
        ...state,
        ...newState
      };

    case DELETE_SPOT_DONE:
      return omit(state, payload);

    default:
      return state;
  }
};

export default parkingSpotReducer;
